import { SVGPropsIcon } from 'src/types';

export const WalletIcon = (props: SVGPropsIcon) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <g clipPath="url(#clip0_25891_759)">
      <path
        d="M10.4235 10.0852V11.2231C10.4235 12.7935 11.698 14.068 13.2683 14.068H15.5442V14.6369C15.5442 15.5757 14.7761 16.3438 13.8373 16.3438H2.458C1.5192 16.3438 0.751099 15.5757 0.751099 14.6369V6.6714C0.751099 5.72692 1.5192 4.96451 2.458 4.96451H13.8373C14.7761 4.96451 15.5442 5.72692 15.5442 6.6714V7.24037H13.2683C11.698 7.24037 10.4235 8.51485 10.4235 10.0852ZM17.2511 10.0852V11.2231C17.2511 11.7238 17.0292 12.179 16.6821 12.4919C16.3806 12.765 15.9766 12.93 15.5442 12.93H13.2683C12.3295 12.93 11.5614 12.1619 11.5614 11.2231V10.0852C11.5614 9.14071 12.3295 8.3783 13.2683 8.3783H15.5442C15.9766 8.3783 16.3806 8.5433 16.6821 8.8164C17.0292 9.12364 17.2511 9.57882 17.2511 10.0852ZM14.4063 10.6542C14.4063 10.3412 14.1502 10.0852 13.8373 10.0852C13.5244 10.0852 13.2683 10.3412 13.2683 10.6542C13.2683 10.9671 13.5244 11.2231 13.8373 11.2231C14.1502 11.2231 14.4063 10.9671 14.4063 10.6542ZM12.4775 2.67726C12.3352 2.19364 11.9995 1.80106 11.5444 1.59054C11.0892 1.38571 10.5658 1.38571 10.1106 1.59623L5.33696 3.82657H12.8075L12.4775 2.67726Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_25891_759">
        <rect width="16.5" height="16.5" fill="white" transform="translate(0.75 0.750061)" />
      </clipPath>
    </defs>
  </svg>
);
